import { T } from '@fire/i18n/i18n-constants';

export const NAMESPACE = T?.SearchBar ?? '';
